<template>
  <div class="section-card">
    <p class="section-title mb-0 mt-3 pa-1 pl-5" @click="$emit('cargar-modulos-universidad')">
      Módulos del programa:
      <a class="btn btn-default section-toggle" data-toggle="collapse" href="#collapsemodulos">expandir</a>
    </p>
    <div class="collapse section-body" id="collapsemodulos">

      <v-card
        v-for="m in modulos"
        :key="moduloKey(m)"
        v-show="!moduloEditando || moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)"
        class="modulo-item-card mb-4"
        draggable="true"
        @dragstart="$emit('drag-start', m)"
        @dragover.prevent
        @drop="$emit('drop', m)"
        @dragend="$emit('drag-end')"
        :class="{ dragging: draggedModulo === m }"
        :elevation="draggedModulo === m ? 0 : 3"
        shaped
      >
        <v-card-text class="pa-3">
          <v-row dense align="center">
            <v-col cols="auto" class="drag-handle">
              <v-icon color="grey darken-1">mdi-drag-vertical</v-icon>
            </v-col>

            <v-col cols="12" sm="1" class="text-center">
              <v-chip small color="primary" text-color="white" label class="font-weight-bold">{{ m.numero }}</v-chip>
            </v-col>

            <v-col cols="12" sm="3" style="position:relative;z-index:100">
              <span v-if="m.xmodulo">{{ m.xmodulo.nombre }}</span>
              <AModulos v-else :model="m" :zdefault="m"
                :disabled="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || onlyReadAcade" />
            </v-col>

            <v-col cols="12" sm="2" style="position:relative;z-index:99">
              <v-select
                v-if="(moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)) || onlyReadAcade"
                v-model="m.tipo_calificacion"
                :items="tiposCalificacion" item-text="text" item-value="value"
                :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                :disabled="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || onlyReadAcade"
                label="Tipo calificación" dense outlined hide-details />
              <span v-if="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || onlyReadAcade">
                {{ m.tipo_calificacion ? m.tipo_calificacion.replace(/_/g, ' ') : 'No tiene' }}
              </span>
            </v-col>

            <v-col cols="12" sm="2">
              <v-text-field v-model.trim="m.fecha_inicio"
                :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                :disabled="onlyReadAcade" type="date" label="Fecha inicio" dense outlined hide-details />
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field v-model.trim="m.fecha_fin"
                :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                :disabled="onlyReadAcade" type="date" label="Fecha fin" dense outlined hide-details />
            </v-col>

            <v-col cols="12" sm="1" class="text-center">
              <template v-if="moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)">
                <v-btn icon x-small @click="$emit('guardar-modulo', m)">
                  <v-icon small style="color:#28A745!important">mdi-check</v-icon>
                </v-btn>
                <v-btn icon x-small @click="$emit('cancelar-edicion')">
                  <v-icon small style="color:red!important">mdi-close</v-icon>
                </v-btn>
              </template>
              <template v-else>
                <v-btn icon x-small :disabled="onlyReadAcade" @click="$emit('editar-modulo', m)">
                  <v-icon small style="color:#FFB300!important">mdi-pencil</v-icon>
                </v-btn>
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" :disabled="onlyReadAcade" @click="$emit('open-edit-mod', m)">
                      <v-icon small style="color:#FFB300!important">mdi-pencil-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar módulo completo</span>
                </v-tooltip>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="mt-4 d-flex" style="gap:8px">
        <v-btn v-if="!$route.query.programa_universidad_id" :disabled="onlyReadAcade" color="error" outlined small @click="$emit('add-modulo', 0)">
          <v-icon small left>mdi-minus</v-icon>Quitar módulo
        </v-btn>
        <v-btn :disabled="onlyReadAcade" color="success" outlined small @click="$emit('add-modulo', 1)">
          <v-icon small left>mdi-plus</v-icon>Agregar módulo
        </v-btn>
      </div>

      <a v-if="!$route.query.programa_universidad_id" class="btn btn-link btn-sm" style="margin-left:84px"
        data-toggle="collapse" href="#collapseExamplem">
        Crear Nuevo Módulo si No existe (opcional)
      </a>

      <div class="collapse" id="collapseExamplem">
        <NewModulo />
      </div>
    </div>
  </div>
</template>

<script>
import AModulos from '@/components/ASelecionar-modulo';
import NewModulo from '@/components/AModulosCrear';
export default {
  name: 'SeccionModulos',
  components: { AModulos, NewModulo },
  props: {
    modulos: { type: Array, default: () => [] },
    moduloEditando: { default: null },
    draggedModulo: { default: null },
    tiposCalificacion: { type: Array, default: () => [] },
    onlyReadAcade: { type: Boolean, default: false },
  },
  methods: {
    moduloKey(m) {
      return m.programa_modulo_id || m.modulo_id || m.numero || m._tempId || Math.random();
    },
  },
};
</script>

<style scoped>
.section-card { background:#fff; border:1px solid #e6e9f0; border-radius:12px; padding:14px 14px 6px; margin-top:16px; box-shadow:0 4px 12px rgba(0,0,0,.04); }
.section-title { display:flex; align-items:center; justify-content:space-between; border-radius:10px; background:linear-gradient(90deg,#e3f2fd 0%,#ede7f6 100%); color:#1e3a8a; font-weight:600; cursor:pointer; }
.section-toggle { color:#3949ab; font-weight:600; }
.section-body { padding-top:10px; }
.modulo-item-card { cursor:move; user-select:none; transition:all .3s cubic-bezier(.4,0,.2,1); background:linear-gradient(145deg,#fff 0%,#f8f9ff 100%); border-left:4px solid #5e35b1; border-radius:12px!important; overflow:visible!important; position:relative; }
.modulo-item-card:hover { box-shadow:0 8px 24px rgba(94,53,177,.25); transform:translateY(-4px) scale(1.01); border-left-color:#1e88e5; }
.modulo-item-card.dragging { opacity:.6; border:3px dashed #1e88e5; background:linear-gradient(145deg,#e3f2fd 0%,#ede7f6 100%); transform:scale(1.05) rotate(2deg); z-index:1000; }
.drag-handle { cursor:grab; transition:all .2s ease; padding:8px; border-radius:8px; }
.drag-handle:hover { background:rgba(94,53,177,.1); transform:scale(1.2); }
.drag-handle:active { cursor:grabbing; }
::v-deep .v-input, ::v-deep .v-select, ::v-deep .v-autocomplete { position:relative; z-index:100; }
</style>
